/**
 * Return a language identifier suitable for backend endpoints that accept a
 * TTS/Whisper language (`/api/poc/tts`, `/api/poc/analyze-pronunciation`, etc.).
 *
 * The backend resolver accepts ANY of: French labels ("anglais",
 * "anglais (britannique)"), ISO codes with or without variant ("en", "en-GB",
 * "es-MX"), native names, and is case-insensitive — so this helper simply
 * passes the identifier through, trimmed. Callers may forward
 * `profile.target_language` (ISO), `session.language_fr` (French label), or
 * any string; the backend will normalize.
 *
 * Returns "anglais" as a last-resort default when the identifier is empty so
 * the request never fails with a 400 on missing param.
 */
export function ttsLanguageOf(identifier) {
    if (!identifier || typeof identifier !== "string") return "anglais";
    return identifier.trim();
}

export const TTS_VOICES = [
    { id: "alloy", label: "Alloy", subtitle: "voix neutre équilibrée" },
    { id: "echo", label: "Echo", subtitle: "voix masculine posée" },
    { id: "fable", label: "Fable", subtitle: "voix narrative expressive" },
    { id: "onyx", label: "Onyx", subtitle: "voix masculine grave" },
    { id: "nova", label: "Nova", subtitle: "voix féminine claire" },
    { id: "shimmer", label: "Shimmer", subtitle: "voix féminine douce" },
];

export const DEFAULT_VOICE = "alloy";

/**
 * Voice threading. All pages that render TTS controls should read the current
 * voice preference from the dashboard context (which mirrors profile.voice)
 * and forward it to /api/poc/tts. This helper centralizes the fallback so a
 * missing/loading profile still produces a working request body.
 */
export function voiceOf(profile) {
    const v = profile?.voice;
    if (!v || typeof v !== "string") return DEFAULT_VOICE;
    return v;
}

